export default __webpack_public_path__ + "static/media/StkTransferOff.540c33bb.svg";